var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-0 mt-0"},[_vm._v("Registrar")]),_c('p',[_vm._v("Ingrese su email y su documento de identidad registrado con anterioridad en Clase Alpha SAS ")]),_c('sign-up1-form',{attrs:{"formType":"firebase"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }